<div class="modal-header">

  <p class="modal-title"><strong> Log details :{{details.message }} </strong></p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>

<div class="modal-body">
  <div class="col-12 form-group">

    <div class="form-group">
      <label> TimeStamp :</label> {{details.timeStamp |  date:'dd-MMM-yy HH:mm:ss'}}
    </div>

    <div class="form-group">
      <label>Level </label> :{{details.level }}
    </div>

    <div class="form-group">
      <label>Exception </label> : {{details.exception }}
    </div>
  </div>
</div>